/**
 * @generated SignedSource<<3b15e3bcdddd298f282e115c410a0d80>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActivateQuery$variables = {
  key: string;
};
export type ActivateQuery$data = {
  readonly loginActivation: {
    readonly hasExistingLogin: boolean;
  } | null;
};
export type ActivateQuery = {
  response: ActivateQuery$data;
  variables: ActivateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasExistingLogin",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActivateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LoginActivation",
        "kind": "LinkedField",
        "name": "loginActivation",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActivateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LoginActivation",
        "kind": "LinkedField",
        "name": "loginActivation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3b713a20caaa845f3f1c324d68fe76cb",
    "id": null,
    "metadata": {},
    "name": "ActivateQuery",
    "operationKind": "query",
    "text": "query ActivateQuery(\n  $key: String!\n) {\n  loginActivation(key: $key) {\n    hasExistingLogin\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f0de95d179dfe2e57611013ca21d60ea";

export default node;
